import { themeMaterial } from 'ag-grid-community';

// Grid colors ported from the legacy theme used in styles.scss.

/** Grid foreground color in dark mode. */
const GridDarkForegroundColor = 'white';
/** Grid background color in dark mode. */
const GridDarkBackgroundColor = '#303030';
/** Grid header background color in dark mode. */
const GridDarkHeaderBackgroundColor = '#424242';
/** Grid header cell hover background color in dark mode. */
const GridDarkHeaderCellHoverBackgroundColor = 'rgba(255, 255, 255, .04)';
/** Grid odd row background color in dark mode. */
const GridDarkOddRowBackgroundColor = '#616161';
/** Grid primary color in dark mode. */
const GridDarkPrimaryColor = '#2c313f';
/** Grid dark row hover color in dark mode. */
const GridDarkRowHoverColor = 'rgba(255, 255, 255, .04)';
/** Grid selected row background color in dark mode. */
const GridDarkSelectedRowBackgroundColor = '#212121';
/** Grid checkbox unchecked color in dark mode. */
const GridDarkCheckboxUncheckedColor = 'transparent';
/** Grid checkbox checked color in dark mode. */
const GridDarkCheckboxCheckedColor = '#607d8b';
/** Grid border color in dark mode. */
const GridDarkBorderColor = '#616161';
/** Grid control panel background color in dark mode. */
const GridDarkControlPanelBackgroundColor = '#424242';
/** Grid tooltip background color in dark mode. */
const GridDarkTooltipBackgroundColor = '#303030';
/** Grid range selection border color in dark mode. */
const GridDarkRangeSelectionBorderColor = '#2c313f';
/** Grid range selection background color in dark mode. */
const GridDarkRangeSelectionBackgroundColor = 'rgba(122, 134, 203, .1)';
/** Grid modal overlay background color in dark mode. */
const GridDarkModalOverlayBackgroundColor = 'rgba(48, 48, 48, .66)';
/** Grid accent color for both light and dark mode. */
const GridAccentColor = '#607d8b';

/** Grid odd row background color in light mode. */
const GridLightOddRowBackgroundColor = '#e3e4e9';
/** Grid primary color in light mode. */
const GridLightPrimaryColor = '#152245';

/** Grid theme options. */
export enum GridTheme {
  dark = 'dark',
  light = 'light',
}

export const globalsearchMaterialTheme = themeMaterial
  .withParams(
    {
      foregroundColor: GridDarkForegroundColor,
      backgroundColor: GridDarkBackgroundColor,
      headerBackgroundColor: GridDarkHeaderBackgroundColor,
      headerCellHoverBackgroundColor: GridDarkHeaderCellHoverBackgroundColor,
      oddRowBackgroundColor: GridDarkOddRowBackgroundColor,
      primaryColor: GridDarkPrimaryColor,
      accentColor: GridAccentColor,
      rowHoverColor: GridDarkRowHoverColor,
      selectedRowBackgroundColor: GridDarkSelectedRowBackgroundColor,
      checkboxUncheckedBackgroundColor: GridDarkCheckboxUncheckedColor,
      checkboxCheckedBackgroundColor: GridDarkCheckboxCheckedColor,
      borderColor: GridDarkBorderColor,
      chromeBackgroundColor: GridDarkControlPanelBackgroundColor,
      tooltipBackgroundColor: GridDarkTooltipBackgroundColor,
      rangeSelectionBorderColor: GridDarkRangeSelectionBorderColor,
      rangeSelectionBackgroundColor: GridDarkRangeSelectionBackgroundColor,
      modalOverlayBackgroundColor: GridDarkModalOverlayBackgroundColor,
    },
    GridTheme.dark
  )
  .withParams(
    {
      oddRowBackgroundColor: GridLightOddRowBackgroundColor,
      primaryColor: GridLightPrimaryColor,
      accentColor: GridAccentColor,
    },
    GridTheme.light
  );
